export default __webpack_public_path__ + "b0736c64c2563e28f02397025a8c2ccc.svg";